import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface GameError {
  id: number;
  dt: string;
  world: string;
  error_code: string;
  version: string;
  platform: string;
}

export interface ErrorStatsResponse {
  total: number;
  list: GameError[];
  graph: { label: string; count: number }[];
  filters: {
    worlds: string[];
    versions: string[];
    platforms: string[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private api = inject(ApiService);

  getErrors(params: any): Observable<ErrorStatsResponse> {
    const queryParams = new URLSearchParams();
    for (const key in params) {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        queryParams.set(key, params[key]);
      }
    }
    return this.api.get(`admin/errors.php?${queryParams.toString()}`).pipe(
      map(res => res.data)
    );
  }
}
